import { authHeader,check419 } from "../helpers";

// import dateFormat from "dateformat";

export const bookingService = {
    getAddRepsList,
    checkHolidayDate,
    getHolidayList,
    getHospitalsList,
    getRepsUsersList,
    getRepsList,
    getKitSetByKit,
    add,
    getList,
    getById,
    getHospitalDetailsById,
    getSetList,
    getSetListForReps,
    update,
    updateStatus,
    updateItemUsedStatus,
    updateItemUsedStatusForReps,
    saveReturn,
    updatePoNumber,
    countByStatus,
    countDispatch,
    saveDispatchs,
    saveCollections,
    updateBookingDates,
    getLog,
    sendMailBeforeBookingDispatch,
    dashboardPOChecked,
    dashboardCheckSet,
    repsUpdate,
    getBookingkitSetList,
    bookingTransfer,
    getHistoricalReport,
    getConsignmentReport,
    getHistoricalReportExport,
    getConsignmentReportExport,
    delete: _delete,
    getBookingList,
    getBookingsExport,
    bookingsForceClosed,
    uCountDispatch,
    countBookingDispatch,
    doPrepare,
    getConsignmentRequest,
    getRejectedConsignmentRequest,
    consignmentssForceClosed,
    isExtraStock
    
};

function getRejectedConsignmentRequest(search) {
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(search),
    };
  
    return fetch(
      process.env.REACT_APP_APIURL + "admin/consinment-request/get-reject",
      requestOptions
    )
      .then(handleResponse)
      .then((getConsignmentRequest) => {
        return getConsignmentRequest;
      });
  }

function getConsignmentRequest(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"admin/consinment-request/get-list", requestOptions).then(handleResponse)
        .then(getConsignmentRequest => {
            return getConsignmentRequest;
        });
}
function getAddRepsList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/kit-additinal-rep",
        requestOptions,
    )
        .then(handleResponse)
        .then(addRepsList => {
            return addRepsList;
        });
}

function getHospitalsList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "hospitals/searchHospitals",
        requestOptions,
    )
        .then(handleResponse)
        .then(hospitalsList => {
            return hospitalsList;
        });
}

function getRepsUsersList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "users/searchUsers",
        requestOptions,
    )
        .then(handleResponse)
        .then(repsUsersList => {
            return repsUsersList;
        });
}

function dashboardPOChecked(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/dashboardPOChecked",
        requestOptions,
    )
        .then(handleResponse)
        .then(updatedList => {
            return updatedList;
        });
}

function dashboardCheckSet(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/dashboard-set-checked",
        requestOptions,
    )
        .then(handleResponse)
        .then(updatedList => {
            return updatedList;
        });
}

function sendMailBeforeBookingDispatch(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/sendMailBeforeBookingDispatch",
        requestOptions,
    )
        .then(handleResponse)
        .then(mailResp => {
            return mailResp;
        });
}

function getRepsList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "users/searchUsers",
        requestOptions,
    )
        .then(handleResponse)
        .then(repsList => {
            return repsList;
        });
}

function getKitSetByKit(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL +
            "sets/getAllSetsUsingKitIdAndBookingIdForEdit",
        requestOptions,
    )
        .then(handleResponse)
        .then(kitSetList => {
            return kitSetList;
        });
}

function getHolidayList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "holidays/getHolidayList",
        requestOptions,
    )
        .then(handleResponse)
        .then(holidayList => {
            return holidayList;
        });
}

function checkHolidayDate(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };
    console.log(requestOptions.body);
    return fetch(
        process.env.REACT_APP_APIURL + "holidays/checkHolidayUsingDate",
        requestOptions,
    )
        .then(handleResponse)
        .then(holidayDate => {
            return holidayDate;
        });
}

function getList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/getBookings",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function getById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader(),
    };

    return fetch(
        process.env.REACT_APP_APIURL + `booking/editBooking/${id}`,
        requestOptions,
    ).then(handleResponse);
}

function getHospitalDetailsById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader(),
    };

    return fetch(
        process.env.REACT_APP_APIURL + `hospitals/getHospital/${id}`,
        requestOptions,
    ).then(handleResponse);
}

function getSetList(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader(),
    };

    return fetch(
        process.env.REACT_APP_APIURL + `booking/used-item-edit/${id}`,
        requestOptions,
    ).then(handleResponse);
}

function getSetListForReps(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader(),
    };

    return fetch(
        process.env.REACT_APP_APIURL + `reps/booking/used-item-edit/${id}`,
        requestOptions,
    ).then(handleResponse);
}

function add(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader()
        ,"Content-Type": "application/json" 
        },
        body: JSON.stringify(bookingInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/saveBookings",
        requestOptions,
    ).then(handleResponse);
}

function update(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),
        "Content-Type": "application/json" 
       },
        body: JSON.stringify(bookingInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/updateBookings",
        requestOptions,
    ).then(handleResponse);
}

function updateStatus(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(bookingInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/updateBookingStatus",
        requestOptions,
    ).then(handleResponse);
}

function updateItemUsedStatus(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader() },
        body: bookingInfo,
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/used-item-update",
        requestOptions,
    ).then(handleResponse);
}

function updateItemUsedStatusForReps(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader() },
        body: bookingInfo,
    };

    return fetch(
        process.env.REACT_APP_APIURL + "reps/booking/used-item-update",
        requestOptions,
    ).then(handleResponse);
}

function saveReturn(returnInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(returnInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/saveReturns",
        requestOptions,
    ).then(handleResponse);
}

function updatePoNumber(data) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(data),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/updatePONumber",
        requestOptions,
    ).then(handleResponse);
}

function countByStatus(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/countBookings",
        requestOptions,
    )
        .then(handleResponse)
        .then(countInfo => {
            return countInfo;
        });
}

function countDispatch(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/countBookings",
        requestOptions,
    )
        .then(handleResponse)
        .then(countDispatch => {
            return countDispatch;
        });
}

function uCountDispatch(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/countPastBookingDispatch",
        requestOptions,
    )
        .then(handleResponse)
        .then(countDispatch => {
            return countDispatch;
        });
}





function saveDispatchs(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/saveDispatchs",
        requestOptions,
    ).then(handleResponse);
}

function saveCollections(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/saveCollections",
        requestOptions,
    ).then(handleResponse);
}

function updateBookingDates(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/updateBookingDates",
        requestOptions,
    ).then(handleResponse);
}

function getLog(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/getBookingLogUsingBookingId",
        requestOptions,
    )
        .then(handleResponse)
        .then(logList => {
            return logList;
        });
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(id),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "hospitals/deleteHospitals",
        requestOptions,
    ).then(handleResponse);
}

function repsUpdate(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(bookingInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/updateRepsAndAdditionalRepsInBooking",
        requestOptions,
    ).then(handleResponse);
}

function getBookingkitSetList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "sets/getBookigKitSetsUsingBookingId",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function bookingTransfer(bookingInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(bookingInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/getTransferOrDuplicateBookings",
        requestOptions,
    ).then(handleResponse);
}

function getHistoricalReport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "report/getHistoricalReport",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function getConsignmentReport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "report/getConsignmentReport",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function getHistoricalReportExport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "report/getHistoricalReportExport",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function getConsignmentReportExport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "report/getConsignmentReportExport",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function getBookingList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/getBookingList",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function getBookingsExport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/getBookingsExport",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}


function bookingsForceClosed(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/closeSelectedBookings",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function consignmentssForceClosed(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "admin/consinment-booking/closeSelectedBookings",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function countBookingDispatch(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/countBookingDispatch",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}



function doPrepare(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/do-prepare",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}

function isExtraStock(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "booking/is-extra-stock",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}






function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        //const data = text;
        if (!response.ok) {
            if (response.status === 400) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
                const error = (data && data.data.errors) || response.statusText;
                return Promise.reject(error);
            } else if(response.status === 419){
                check419();
            }

            // const error = (data && data.message) || response.statusText;
            // return Promise.reject(error);
        }

        return data;
    });
}
